"use client";
import { skillsData2, skillGroups } from "../../../../utils/data/skills";
import Image from "next/image";
import { InfiniteMovingCards } from "@/components/ui/infinite-moving-cards";
import SectionHeading from "../../section-heading";

function Skills() {
  const movingItems = skillGroups.flatMap((group) =>
    group.items.map((item) => ({
      quote: item,
      name: group.title,
      title: "Core stack",
    }))
  );

  return (
    <section id="skills" className="relative py-24 overflow-hidden">
      <SectionHeading
        eyebrow="[Skills]"
        title="Tools I"
        highlight="ship with"
        description="Frontend-first, with growing ASP.NET Core API experience and a focus on performance."
      />

      <div className="flex flex-wrap justify-center gap-4 mb-12 px-4">
        {skillsData2.map((skill) => (
          <div
            key={skill.name}
            className="flex items-center gap-3 rounded-2xl border border-white/10 bg-neutral-900/50 px-4 py-3 hover:border-violet-500/40 transition-colors"
          >
            <Image src={skill.image} alt={skill.name} width={32} height={32} className="rounded-sm" />
            <span className="text-sm text-neutral-200">{skill.name}</span>
          </div>
        ))}
      </div>

      <div className="rounded-md flex flex-col antialiased items-center justify-center relative overflow-hidden">
        <InfiniteMovingCards items={movingItems} direction="right" speed="slow" />
        <InfiniteMovingCards items={movingItems.slice().reverse()} direction="left" speed="slow" />
      </div>
    </section>
  );
}

export default Skills;
